import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import GeneralBackButton from "../../../components/common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import DynamicDatatable from "../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayHeading from "../../../components/common/AdminCommonComponents/GrayHeading/GrayHeading"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import Toggle from "../../../components/common/AdminCommonComponents/Toggle/Toggle"
import DynamicButton from "../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDropdown from "../../../components/common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"

const SocialMediaLinks = () => {
  const socialMediaLinksTableData = [
    { sr: "1", forum: "Facebook", link: "Facebook.com", status: <Toggle /> },
    { sr: "2", forum: "Twitter", link: "Twitter.com", status: <Toggle /> },
    { sr: "3", forum: "LinkedIn", link: "LinkedIn.com", status: <Toggle /> },
  ]

  const cols = [
    { name: "Sr.", selector: (row) => row.sr, center: "true" },
    { name: "Forum", selector: (row) => row.forum, center: "true" },
    { name: "Link", selector: (row) => row.link, center: "true" },
    { name: "Status", selector: (row) => row.status, center: "true" },
    { name: "Action", cell: () => <button style={{ all: "unset" }}>Edit</button>, center: "true" },
  ]

  const nameOptions = [{ label: "Facebook" }, { label: "Twitter" }, { label: "LinkedIn" }]

  return (
    <LightGrayBgWrapper>
      <div className="shadow">
        <div className="fs-5 fw-semibold bg-white p-3">Social Media</div>
        <DynamicDatatable data={socialMediaLinksTableData} columns={cols} type="yellow" />
      </div>

      <div className="bg-white shadow px-4 p-3 mt-3">
        <GeneralBackButton />
        <div className="d-flex justify-content-center">
          <GrayHeading>Add/Edit Template</GrayHeading>
        </div>

        <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <Row className="row-cols-1 row-cols-md-2">
            <Col>
              <Row className="g-0">
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="Name">
                      Name
                    </Label>
                    <DynamicDropdown options={nameOptions} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  {/* <FormGroup>
                  <Label className="fw-medium" for="appliesTo">
                    Applies To
                  </Label>
                </FormGroup> */}
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="g-0">
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="socialMediaLink">
                      Social Media Link
                    </Label>
                    <Input id="socialMediaLink" name="socialMediaLink" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  {/* <FormGroup>
                  <Label className="fw-medium" for="status">
                    Status
                  </Label>
                  <Input id="status" name="status" placeholder="" type="text" />
                </FormGroup> */}
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="d-flex justify-content-center gap-3 my-3">
            <DynamicButton theme="blue" outline>
              Cancel
            </DynamicButton>
            <DynamicButton theme="blue">Save</DynamicButton>
          </div>
        </Form>
      </div>
    </LightGrayBgWrapper>
  )
}

export default SocialMediaLinks
